import React from 'react';

import { Box, Link, WorkflowViewContainer } from 'components/AORedesign';
import { UserAdminDeleteDuplicateEmail } from 'components/AORedesignViews/UserAdmin';
import { Feature } from 'components/Feature';
import featureFlags from 'constants/featureFlags';

const UserAdminDeleteDuplicateEmailLink = () => {
  const TriggerButton = (props) => <Link {...props}>Delete Duplicate Email</Link>;

  return (
    <Feature allowed={featureFlags.ACCESS_SUPER_ADMIN}>
      <WorkflowViewContainer appBarTitle={'Delete Duplicate Email'} TriggerButton={TriggerButton} block>
        <Box mx={9} my={5}>
          <UserAdminDeleteDuplicateEmail />
        </Box>
      </WorkflowViewContainer>
    </Feature>
  );
};

export default UserAdminDeleteDuplicateEmailLink;
